import { Helmet } from "react-helmet";

interface StructuredDataProps {
  type: 'Organization' | 'LocalBusiness' | 'Service' | 'WebPage' | 'FAQPage' | 'BlogPosting' | 'Article';
  data: Record<string, any>;
}

const StructuredData = ({ type, data }: StructuredDataProps) => {
  const baseData = {
    "@context": "https://schema.org",
    "@type": type,
    ...data
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(baseData)}
      </script>
    </Helmet>
  );
};

export default StructuredData;
